module.exports = __webpack_public_path__ + "static/media/ClarikaOfficeGeo-Rg.1c670305.woff";